export const ObjectiveType = {
    INDIVIDUAL: 'Individual',
    TEAM: 'Team',
} as const;

export type ObjectiveTypeValue = (typeof ObjectiveType)[keyof typeof ObjectiveType];
